import {FC, useState} from "react";
import {copyToClipboard} from "../CommonHtml";
import {Title} from "../../app/CommonUIComponenets";
import {Button} from "../Inputs";
import {icn} from "../UIIcons";

const MAIL = "support@remedio.io";
const SESSION_KEY = "session_message_log";

export const ErrorBoundaryFallback: FC<IErrorBoundaryFallbackProps> = ({msg}) => {
    const [isCopied, setCopied] = useState<boolean>(false);

    const {alreadyShown} = getIsShownMessage(msg);

    const handleCopyToClipboard = () => {
        copyToClipboard(MAIL).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };
    const handleReload = () => {
        saveMessageOncePerHour(msg);
        window.location.reload();
    };
    return (
        <div className="flex items-center justify-center h-full w-full">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col items-center justify-center pb-8">
                    <div className="bg-sec/10 border border-sec/30 grid h-24 w-24 rounded-full place-items-center p-4">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 3.5 2.8 20.5h18.4L12 3.5Z"
                                className="stroke-sec/60"
                                strokeWidth="2"
                                strokeLinejoin="round"/>
                            <path d="M12 9v5" className="stroke-sec/60" strokeWidth="2" strokeLinecap="round"/>
                            <circle cx="12" cy="17" r="1.2" className="stroke-sec/60"/>
                        </svg>
                    </div>
                </div>
                <div className="flex flex-col items-center gap-10 justify-center">
                    <div className="flex flex-col justify-center items-center gap-2">
                        <Title className="text-lg font-bold">Something went wrong</Title>
                        <Title className="text-center text-subtitle1">we had a problem while rendering this page.</Title>
                    </div>
                </div>
                <Button
                    onClick={handleReload}
                    className="px-10 py-2 flex gap-2 self-center justify-center text-prm-contrast bg-blue-500 w-fit"
                    disabled={alreadyShown}>
                    <div className="icon-loop2 w-[10px] h-[10px]"></div>
                    Reload
                </Button>
                <div className="flex justify-center items-center gap-2">
                    <Title className="text-xs !text-icon">{`Timestamp: ${formatTimestamp()}`}</Title>
                </div>
                <div className="border-t p-2 flex flex-col gap-1">
                    <div className="text-subtitle1">If this keeps happening, contact us and we'll help you fix it.</div>

                    <div
                        className="flex gap-1 items-center cursor-pointer hover:opacity-80 active:opacity-90"
                        onClick={handleCopyToClipboard}>
                        <span className="text-prm-light">Email: {MAIL}</span>
                        {icn[isCopied ? "success" : "copy"]("text-prm-light")}
                    </div>
                </div>
            </div>
        </div>
    );
};

function formatTimestamp() {
    const date = new Date();
    return "T" + date.toISOString().slice(0, 19).replace("T", ":");
}

function getIsShownMessage(message: string) {
    const NOW = Date.now();
    const ONE_HOUR = 60 * 60 * 1000;

    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        const store = raw ? JSON.parse(raw) : {};

        const lastShown = store[message];

        if (lastShown && (NOW - lastShown < ONE_HOUR))
            return {alreadyShown: true};


        return {alreadyShown: false};
    } catch {
        return {alreadyShown: false};
    }
}


function saveMessageOncePerHour(message: string) {
    const NOW = Date.now();

    const raw = sessionStorage.getItem(SESSION_KEY);
    const store = raw ? JSON.parse(raw) : {};

    store[message] = NOW;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(store));
}


interface IErrorBoundaryFallbackProps {
    msg: string;
}
